module.exports = __webpack_public_path__ + "img/main_game_l720.bf356548.png";